/**
 * Fixtures das telas internas de Pipelines no modo mock:
 *  - GET /pipeline-stage-card/:id           → card aberto
 *  - GET /pipeline-stage-card-task          → tarefas do card
 *  - GET /pipeline-stage-card-activity      → timeline do card
 *  - GET /crm-automation                    → automações
 *  - GET /pipeline-templates                → modelos de pipeline
 *  - GET /pipeline/:id  e  /pipeline/:id/admins → edição de pipeline
 *
 * Valores monetários em CENTAVOS (o front divide por 100).
 */

import moment from "moment";

const brl = reais => Math.round(reais * 100);
const daysAgo = n => moment().subtract(n, "days").format("YYYY-MM-DD HH:mm:ss");
const inDays = n => moment().add(n, "days").format("YYYY-MM-DD");

const ADMIN = { id: 1, name: "Marina Souza", email: "marina@starbrindes.com.br", photo_url: null };

// ---------------------------------------------------------------------------
// Card aberto (/crm/card/:id)
// ---------------------------------------------------------------------------

// Card comercial: oportunidade vinda de um orçamento, em Follow up.
export const CARD_RESPONSE = {
    resource: {
        id: 6,
        code: "8814",
        pipeline_id: 1,
        pipeline_card_status_mode: "commercial",
        amount: brl(42900),
        status: "open",
        temperature: "warm",
        color: "",
        closing_date: inDays(6),
        created_at: daysAgo(9),
        updated_at: daysAgo(1),
        origin: "indicacao",
        admin: ADMIN,
        company: { id: 1, trade_name: "Banco Meridiano", city: "São Paulo", state: "SP" },
        customer: { id: 1, name: "Sofia Cardoso" },
        crm_tags: [{ id: 5, name: "Alto valor", color: "#6C4CE0" }],
        stages: [
            { id: 101, name: "Orçamento", is_current: false, days_in_stage: 2 },
            { id: 102, name: "Follow up", is_current: true, days_in_stage: 3 },
            { id: 103, name: "Amostra virtual", is_current: false, days_in_stage: 0 },
            { id: 104, name: "Contrato", is_current: false, days_in_stage: 0 },
        ],
        related_order: null,
        order_item: null,
        budget: {
            id: 8814,
            code: "8814",
            total: brl(42900),
            items_count: 3,
            status_name: "Aguardando aprovação",
            status_color: "#3D5980",
            created_at: daysAgo(9),
        },
    },
};

export const COMPANY_RESPONSE = {
    resource: {
        id: 1,
        trade_name: "Banco Meridiano",
        company_name: "Meridiano Instituição Financeira S.A.",
        phone: "1133285400",
        segment: "financeiro",
        employee_range: "201_500",
        website: "https://bancomeridiano.com.br",
        filled_percentage: "80% preenchido",
        updated_at: daysAgo(3),
    },
};

export const CUSTOMER_RESPONSE = {
    resource: {
        id: 1,
        name: "Sofia Cardoso",
        email: "sofia.cardoso@bancomeridiano.com.br",
        phone: "11987654321",
        position: "marketing",
        department: "marketing",
        filled_percentage: "100% preenchido",
        updated_at: daysAgo(3),
    },
};

// ---------------------------------------------------------------------------
// Tarefas e timeline do card
// ---------------------------------------------------------------------------

export const CARD_TASKS_RESPONSE = {
    resources: [
        {
            id: 1,
            pipeline_stage_card_id: 1,
            type: "call",
            status: "pending",
            content: "Sofia pediu para falar com você antes de fechar — confirmar as condições de pagamento.",
            admin_id: 1,
            admin_name: "Marina Souza",
            admin_email: "marina@starbrindes.com.br",
            date: moment().format("YYYY-MM-DD"),
            time: "15:00:00",
        },
        {
            id: 2,
            pipeline_stage_card_id: 1,
            type: "email",
            status: "pending",
            content: "Enviar a amostra virtual com a marca aplicada nos 3 itens do orçamento.",
            admin_id: 3,
            admin_name: "Ana Beatriz Costa",
            admin_email: "ana@starbrindes.com.br",
            date: inDays(2),
            time: "",
        },
        {
            id: 3,
            pipeline_stage_card_id: 1,
            type: "meeting",
            status: "completed",
            content: "Reunião de apresentação da linha de brindes para a campanha de fim de ano.",
            admin_id: 1,
            admin_name: "Marina Souza",
            admin_email: "marina@starbrindes.com.br",
            date: moment().subtract(4, "days").format("YYYY-MM-DD"),
            time: "10:30:00",
        },
    ],
};

export const CARD_ACTIVITIES_RESPONSE = {
    resources: [
        {
            id: 1,
            pipeline_stage_card_id: 1,
            type: "comments",
            content: "Cliente falou que quer conversar com você antes de fechar. @[Carlos Mendes] consegue ligar hoje à tarde?",
            admin_id: 1,
            admin_name: "Marina Souza",
            admin_email: "marina@starbrindes.com.br",
            created_at: daysAgo(1),
            updated_at: daysAgo(1),
        },
        {
            id: 2,
            pipeline_stage_card_id: 1,
            type: "comments",
            content: "Cliente pediu para incluir a mochila na proposta. Orçamento revisado e reenviado.",
            admin_id: 2,
            admin_name: "Carlos Mendes",
            admin_email: "carlos@starbrindes.com.br",
            created_at: daysAgo(5),
            updated_at: daysAgo(5),
        },
        {
            id: 3,
            pipeline_stage_card_id: 1,
            type: "budget",
            content: "Orçamento #8814 enviado com 3 opções para a campanha de fim de ano.",
            admin_id: 1,
            admin_name: "Marina Souza",
            admin_email: "marina@starbrindes.com.br",
            created_at: daysAgo(12),
            updated_at: daysAgo(12),
        },
    ],
};

// ---------------------------------------------------------------------------
// Automações
// ---------------------------------------------------------------------------

const pipelineRef = (id, name) => ({ id, name });

export const AUTOMATION_RESPONSE = {
    resources: [
        {
            id: 1,
            trigger: "budget_created",
            pipeline_id: 1,
            pipeline_stage_id: 101,
            pipeline: pipelineRef(1, "Comercial"),
            stage: pipelineRef(101, "Orçamento"),
            conditions: null,
            action_config: {},
            is_active: true,
            order: 1,
        },
        {
            id: 2,
            trigger: "order_created",
            pipeline_id: 2,
            pipeline_stage_id: 201,
            pipeline: pipelineRef(2, "Produção"),
            stage: pipelineRef(201, "Pedido recebido"),
            conditions: null,
            action_config: { card_creation_mode: "per_product", card_responsible_mode: "order_admin" },
            is_active: true,
            order: 1,
        },
        {
            id: 3,
            trigger: "card_entered_stage",
            pipeline_id: 2,
            pipeline_stage_id: 204,
            pipeline: pipelineRef(2, "Produção"),
            stage: pipelineRef(204, "Personalização"),
            conditions: null,
            action_config: {
                task_type: "task",
                task_title: "Conferir arte aprovada antes de gravar",
                task_due_offset_days: 1,
            },
            is_active: true,
            order: 1,
        },
        {
            id: 4,
            trigger: "order_created",
            pipeline_id: 3,
            pipeline_stage_id: 301,
            pipeline: pipelineRef(3, "Financeiro"),
            stage: pipelineRef(301, "Emissão de nota"),
            conditions: [{ type: "amount", operator: "gte", value: brl(5000) }],
            action_config: { card_creation_mode: "per_order", card_responsible_mode: "fixed_admin" },
            is_active: false,
            order: 2,
        },
    ],
};

// ---------------------------------------------------------------------------
// Modelos e edição de pipeline
// ---------------------------------------------------------------------------

const template = (key, name, icon, description, stages, automations = []) => ({
    key,
    name,
    icon,
    description,
    stages: stages.map((stageName, index) => ({ name: stageName, order: index + 1, max_days_in_stage: 3 })),
    automations,
});

export const PIPELINE_TEMPLATES_RESPONSE = {
    resources: [
        template("comercial", "Comercial", "💼", "Acompanhe o orçamento até o fechamento da venda.",
            ["Orçamento", "Follow up", "Amostra virtual", "Contrato"],
            [{ trigger: "budget_created", action_config: {} }]),
        template("producao", "Produção", "🏭", "Do pedido recebido até a separação para envio.",
            ["Pedido recebido", "Compras", "Aguardando chegada", "Personalização", "Controle de qualidade", "Separação"],
            [{ trigger: "order_created", action_config: { card_creation_mode: "per_product" } }]),
        template("financeiro", "Financeiro", "💰", "Controle a emissão da nota e o recebimento.",
            ["Emissão de nota", "Pagamento parcial", "Pagamento confirmado"],
            [{ trigger: "order_created", action_config: { card_creation_mode: "per_order" } }]),
        template("pos-venda", "Pós-venda", "🤝", "Garanta a entrega e reative o cliente.",
            ["Entrega confirmada", "Pesquisa de satisfação", "Recompra"]),
    ],
};

const PIPELINE_DETAILS = {
    1: {
        id: 1,
        name: "Comercial",
        icon: "💼",
        card_status_mode: "commercial",
        allow_manual_card_creation: true,
        stages: [
            { id: 101, name: "Orçamento", order: 1, max_days_in_stage: 2 },
            { id: 102, name: "Follow up", order: 2, max_days_in_stage: 5 },
            { id: 103, name: "Amostra virtual", order: 3, max_days_in_stage: 4 },
            { id: 104, name: "Contrato", order: 4, max_days_in_stage: 7 },
        ],
    },
    2: {
        id: 2,
        name: "Produção",
        icon: "🏭",
        card_status_mode: "operational",
        allow_manual_card_creation: true,
        stages: [
            { id: 201, name: "Pedido recebido", order: 1, max_days_in_stage: 2 },
            { id: 202, name: "Compras", order: 2, max_days_in_stage: 5 },
            { id: 203, name: "Aguardando chegada", order: 3, max_days_in_stage: 10 },
            { id: 204, name: "Personalização", order: 4, max_days_in_stage: 4 },
            { id: 205, name: "Controle de qualidade", order: 5, max_days_in_stage: 2 },
            { id: 206, name: "Separação", order: 6, max_days_in_stage: 2 },
        ],
    },
};

export const pipelineDetailFor = id => ({ resource: PIPELINE_DETAILS[Number(id)] ?? PIPELINE_DETAILS[1] });

export const PIPELINE_ADMINS_RESPONSE = {
    resources: [
        { id: 1, name: "Marina Souza", email: "marina@starbrindes.com.br", photo_url: null },
        { id: 2, name: "Carlos Mendes", email: "carlos@starbrindes.com.br", photo_url: null },
        { id: 3, name: "Ana Beatriz Costa", email: "ana@starbrindes.com.br", photo_url: null },
        { id: 4, name: "Rafael Almeida", email: "rafael@starbrindes.com.br", photo_url: null },
    ],
};
